import { useEffect } from 'react'
import { connect } from 'react-redux'

import ReactGA from 'react-ga'
import Cookies from 'js-cookie'

let inicializado = false

export const gaInitialize = (gaId) => {
  if (typeof gaId !== 'undefined'){
    ReactGA.initialize(gaId)
    inicializado = true
  }
}

export const MiCookies = ({gaId,idProyecto}) => {
  useEffect(() => {
    if (Cookies.get(`CookieConsent${idProyecto}`)) {
      gaInitialize(gaId)
    }
  })
  return null
}

export const gaPageview = page => {
  if (inicializado) ReactGA.pageview(page)
}

export const gaEvent = e => {
  if (inicializado) ReactGA.event(e)
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    idProyecto:reducer.idProyecto,
    gaId: reducer.gaId
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MiCookies)



/*
Cambiar opción:

category: 'Opción seleccionada',
action: Estancia,
label: Opcion


Cambiar idioma

category: 'Selección idioma',
action: Idioma


Ver información

category: 'Ver información'
action: 'Ver información'


Resetear configuración

category: 'Resetear configuración'
action: 'Resetear configuración'


Generar pdf

category: 'Generar pdf'
action: 'Generar pdf'


Generar pdf opción:

category: 'Opción en pdf',
action: estancia
label: Opcion


Guardar configuración

category: 'Opción guardada',
action: estancia
label: Opcion




*/
